<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>[{{model.type ? model.type.toUpperCase() : '-'}}]</strong>
            <strong>{{model.title}}</strong> <span class="float-right">{{model.created_at | sdate}}</span>
          </div>
          <b-row>
            <b-col md="12">
              <select v-model="model.type" class="w-100" :disabled="lock">
                <option disabled value="">Please select solution</option>
                  <option value="webcastle">WEBCastle : Web Firewall</option>
                  <option value="wsfinder">WSFinder : Anti-Webshell</option>
                  <option value="wmds">WMDS : Web Malware Detection System</option>
                  <option value="wfdetector">WFDetector : Web Forgery Detection</option>
                  <option value="etc">Etc</option>
              </select>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_title">Title</label>
                <b-form-input disabled="lock" md=5 type="text" id="ph_title" v-model="model.title"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <h4 for="ph_question">Content</h4>
              <vue-editor disabled="lock" v-model="model.content" id="ph_question"></vue-editor>
            </b-col>
          </b-row>
          <hr>
          <!-- <b-button size="sm" variant="success" @click="save"> Save </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Remove </b-button> -->
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm" @ok="remove(model)" ok-variant="danger">
      Are you sure you want to delete the data?
    </b-modal>
    <!-- {{model}} -->
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { Api } from '@/service';
export default {
  components: { VueEditor },
  data : () => ({ confirm: false, add: false, lock: true, model : { type : '' } }),
  methods: {
    cancel() { this.lock = true; },
    async update(m) {
      if(!(m.title || '').trim()) { return this.$toastr.e('Title is Require.'); }
      if(!(m.content || '').trim()) { return this.$toastr.e('Content is Require.'); }
      try {
        let rs = await Api.Partner_Call('borad.faq', m.id ? 'update' : 'insert', m);
        if(!rs.error) {
          this.$toastr.s('Saved.', this.$route.name);this.$emit('refresh'); this.cancel();
        } else {
          this.$toastr.e('save', "failed"); this.$emit('refresh'); this.cancel();
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
      m.edit = false;
    },
    async remove() {
      try {
        let rs = await Api.Partner_Call('board.faq', 'remove', { id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name)
        } else {
          console.log("remove", 'failed', rs.reason, this.model.id)
          this.$toastr.e('remove', "failed")
        }
        this.list(); this.$emit('refresh')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    async save() {
      if(!(this.model.type || '').trim()) { return this.$toastr.e('Solution is Require.'); }
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title is Require.'); }
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content is Require.'); }

      try {
        let rs = await Api.Partner_Call('board.faq', this.model.id ? 'update' : 'insert', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          return this.$router.push({ name : 'board_faq', params : { id : rs.body.id } });
        } else {
          this.$toastr.s('Save', 'failed');
        }
        this.cancel();
        this.get();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    list() { this.$router.push({ name: 'board_faq'}); },
    async get(id = this.$route.params.id) {
      console.log('faq.detail.vue', 'load item', id);
      if(id !== 'add') {
        try {
          let rs = await Api.Partner_Call('board.faq', 'detail', { id : id });
          this.model = Object.assign({}, this.model, rs.body );
          return;
        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
      }
      this.lock = false;
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); } },
  created() { console.log('faq.detail.vue', 'created'); },
  destroyed() { console.log('faq.detail.vue', 'destroyed'); },
  mounted() { console.log('faq.detail.vue', 'mounted'); this.get(this.$route.params.id); },
}
</script>
